export const suggestedQuestions = {
  clientMetric: [
    "What is their address?",
    "Which industry do they belong?",
    "What is their employee strength?",
  ],
  clientPulse: [
    "Top 3 focus areas​",
    "Any negative news sentiments in the market",
    "What are the early warning signs captured in last 3 months",
  ],
  industryInsights: [
    "Summarize the latest regulations announced by Indonesian government?",
    "Who are the main competitors of my client in the market?",
    "List 3 growth areas that the competitors are focusing on",
  ],
  clientMeetingPrep: [
    // "List action items from my last meeting?",
    // "Summarize the key questions which can be discussed with director finance in my next meeting",
    // "What are the different products which can be offered to client?",
    "Top 3 focus areas​",
    "Any negative news sentiments in the market",
    "What are the early warning signs captured in last 3 months",
  ],
  notification: [
    "What are my planned meetings for next week?",
    "Has any of my client's quarterly reports been released?",
    "Is there anything I should know that would be helpful for my client conversations?",
  ],
  default: [
    "Top 3 focus areas for Pertamina",
    "What are the key news trending for Pertamina?",
    "Any negative news sentiment in the market",
  ],
};

export const initialMessagesData = (userName) => {
  return {
    clientMetric: {
      first: `Welcome, ${userName}`,
      second:
        "I’m your GenAI-powered assistant Coba, here to keep you informed and ahead",
      third: "Get a 360o view of your client’s portfolio:",
      list: [
        "Instantly access key details like company profile, ownership structure, revenue, and product holdings.​",
        "Track customer transactions, upcoming payments, and financial covenants.​",
        "Stay ahead with real-time signals for risks and opportunities​",
      ],
      last: "Have a question about a client? Just ask, and I’ll fetch the details for you",
    },
    clientPulse: {
      first: `Welcome, ${userName}`,
      second:
        "I’m your GenAI-powered assistant Coba, here to keep you informed and ahead",
      third: "Here’s how I can help you ",
      list: [
        "Detect early warning signs and uncover new business opportunities.​",
        "Stay informed with real-time news, analyst reports, and financial health insights.​",
        "Understand where your client is prioritizing efforts and investments",
      ],
      last: "Let me know if you need a deeper dive!",
    },
    industryInsights: {
      first: `Welcome, ${userName}`,
      second:
        "I’m your GenAI-powered assistant Coba, providing a strategic view of your client’s industry landscape",
      third: "Here’s how I can help you",
      list: [
        "Understand market trends, competitor strategies, and industry benchmarks.​",
        "Stay ahead of regulatory updates, geopolitical shifts, and emerging risks.​",
        "Gain insights into industry disruptions and innovation signals.",
      ],
      last: "Need insights for a specific sector? I’ve got you covered!",
    },
    clientMeetingPrep: {
      // first: `Welcome, ${userName}`,
      // second:
      //   "I’m your GenAI-powered assistant Coba, ensuring you are fully prepared for every client interaction",
      // third: "Here’s how I can help you",
      // list: [
      //   "Get a quick overview of upcoming meeting agendas, discussion points, and follow-ups.​",
      //   "Review past meeting notes, action items, and key client priorities to maintain continuity​",
      //   "Discover next best offers tailored to your client’s needs.",
      // ],
      // last: "Need a quick briefing before your next meeting? Just ask!",
      first: `Welcome, ${userName}`,
      second:
        "I’m your GenAI-powered assistant Coba, here to keep you informed and ahead",
      third: "Here’s how I can help you ",
      list: [
        "Detect early warning signs and uncover new business opportunities.​",
        "Stay informed with real-time news, analyst reports, and financial health insights.​",
        "Understand where your client is prioritizing efforts and investments",
      ],
      last: "Let me know if you need a deeper dive!",
    },
    notification: {
      first: `Welcome, ${userName}`,
      second:
        "I’m your GenAI-powered assistant Coba, keeping you updated on what matters most",
      third: "Here’s how I can help you",
      list: [
        "Stay on top of urgent tasks that need your attention​",
        "Critical client or market changes you need to know​",
        "Relevant industry trends and updates to stay ahead",
      ],
      last: "Have a question? Just ask, and I’ll fetch the details for you ",
    },
    default: {
      first: `Welcome, ${userName}`,
      second: "",
      list: [],
      last: "",
    },
  };
};
